import { ParamsWithPagination } from '@/types/api';
import { NestedNullable } from '@/types/types';

import {
  AudienceChannelSourceFilters,
  ChannelFilters,
  EconomicalValueChannelSourceFilters,
} from '../types';

export const channelsQueryKeys = {
  all: ['channels'] as const,
  lists: () => [...channelsQueryKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<ChannelFilters>) =>
    [...channelsQueryKeys.lists(), params] as const,
  byIds: (ids: string[]) => [...channelsQueryKeys.lists(), 'by-ids', ids] as const,
  id: (id?: string) => [...channelsQueryKeys.all, id] as const,
  audienceChannelSources: (params?: NestedNullable<AudienceChannelSourceFilters>) =>
    [...channelsQueryKeys.all, 'audienceChannelSources', params] as const,
  economicalValueChannelSources: (params?: NestedNullable<EconomicalValueChannelSourceFilters>) =>
    [...channelsQueryKeys.all, 'economicalValueChannelSources', params] as const,
};
